import { inject, NgModule, provideAppInitializer } from '@angular/core';
import { CookieModule } from 'ngx-cookie';
import { provideNgxWebstorage, withNgxWebstorageConfig, SessionStorageService, withLocalStorage, withSessionStorage } from 'ngx-webstorage';

// import { environment } from '../../environments/environment';
import { authExpiredInterceptor } from '../blocks/interceptor/auth-expired.interceptor';
import { authHttpHeadersInterceptor } from '../blocks/interceptor/auth-headers.interceptor';
import { AuthModule, AuthClientConfig, AuthHttpInterceptor } from '@auth0/auth0-angular';
import { HTTP_INTERCEPTORS, HttpBackend, provideHttpClient, withInterceptors } from '@angular/common/http';
import { auth0Initializer } from './auth0Initializer';

@NgModule({
  imports: [CookieModule.withOptions(), AuthModule.forRoot()],
  providers: [
    provideNgxWebstorage(withNgxWebstorageConfig({ prefix: 'wsb', separator: '-' }), withLocalStorage(), withSessionStorage()),
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: auth0Initializer,
    //   deps: [HttpBackend, AuthClientConfig, SessionStorageService],
    //   multi: true
    // },
    { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true },
    provideHttpClient(withInterceptors([authExpiredInterceptor, authHttpHeadersInterceptor])),
    provideAppInitializer(() => {
      const handler = inject(HttpBackend);
      const config = inject(AuthClientConfig);
      const sessionStorage = inject(SessionStorageService);
      return auth0Initializer(handler, config, sessionStorage)();
    })
  ]
})
export class AtlasCoreModule {
  constructor() {}
}
